import FormSubmitActions from '@/utils/actions/form_submit_actions'

import router from "@/router"
import constants from "@/constants/constants"

import form_submit_progress_bar from './modules/form_submit_progress_bar'
import form_submit_fields_validation from '@/store/form_submit/modules/form_submit_fields_validation'
import form_submit_fsp_theme from '@/store/form_submit/modules/form_submit_fsp_theme'
import { useFSPStoreModule } from '@/FSP/fsp_store_module'
import form_submit_conditional_logic_store from './modules/form_submit_conditional_logic_store'
import form_submit_submission_metrics_store from './modules/form_submit_submission_metrics_store'

import { useFieldsEnumerationGettersExtension } from '@/store/util_modules/fields_enumeration_getters'
import { isEmpty } from 'lodash'
import { ResettableExtensions } from '@/xstore/utils/resettable'
import { SMAGableExtensions } from '@/xstore/utils/smagable'
import form_submit_submission_store from '@/store/form_submit/modules/form_submit_submission_store'

export default ({ useExtension }) => {
  {
    const state = {
      form_data: undefined,
      form_source_json: undefined,
      current_page_id: undefined
    }
    useExtension(SMAGableExtensions.SMable, { state })
  }

  {
    const state = {
      form_version_id: undefined
    }
    useExtension(SMAGableExtensions.SMAGable, { state })
  }

  {
    const state = {
      with_submit: undefined
    }
    useExtension(SMAGableExtensions.SMGable, { state })
  }

  {
    const state = {
      before_submit_hooks: {},
      conditional_redirect_url: null
    }
    useExtension(SMAGableExtensions.SGable, { state })
  }

  useExtension(ResettableExtensions.Default)
  useExtension(useFieldsEnumerationGettersExtension({
    isFormStaticGetterName: 'isFormStatic',
    isFormInteractiveGetterName: 'isFormInteractive',
    formJSONGetterName: 'getFormSourceJSON',
    currentPageIdGetterName: 'getCurrentPageID'
  }))

  return {
    modules: {
      FSP: useFSPStoreModule({
        stylePreferencesGetterName: 'FSP_theme/getCurrentStylePreferences'
      }),

      submission: form_submit_submission_store,

      progress_bar: form_submit_progress_bar,
      fields_validation: form_submit_fields_validation,
      FSP_theme: form_submit_fsp_theme,
      conditional: form_submit_conditional_logic_store,
      submission_metrics: form_submit_submission_metrics_store,
    },
    mutations: {
      REGISTER_BEFORE_SUBMIT_HOOK: (state, { hookID, hook }) => state.before_submit_hooks[hookID] = hook,
      SET_CONDITIONAL_REDIRECT_URL: (state, url) => state.conditional_redirect_url = url
    },
    actions: {
      setFieldsValidation: ({ dispatch }) => {
        dispatch('fields_validation/setRules')
      },
      fetchFormSourceJSON: ({ commit, dispatch }, formID) =>
        FormSubmitActions.fetchFormData(formID)
          .then(({ data: response }) => {
            if (response.closed) {
              router.replaceWithoutRedirecting(constants.PAGE_NAME_FORM_NOT_FOUND)
            } else if (response.formData && response.formJson) {
              const { formData, formJson } = response
              commit('SET_FORM_DATA', formData)
              commit('SET_FORM_SOURCE_JSON', response.formJson)
              dispatch('setFormVersionId', response.formData?.publishedVersionID)
              commit('SET_WITH_SUBMIT', true)
              
              // Reset submission metrics to generate new ID for each form load
              console.log('🔄 [FORM LOAD DEBUG] Resetting submission metrics for new form session')
              dispatch('submission_metrics/resetSubmissionMetrics')
              
              return Promise.all([
                dispatch('submission/generateFormSubmission', response.formJson),
                dispatch('FSP_theme/pushThemeObj', response.formData.themeObj)
              ]).then(() => Promise.all([
                dispatch('setFieldsValidation'),
                dispatch('submission_metrics/formSubmitOpened'),
                dispatch('FSP/initializeFSP')
              ]))
            } else {
              router.replaceWithoutRedirecting(constants.PAGE_NAME_NOT_FOUND)
            }
          }),

      pushFormSource: async ({ commit, dispatch }, {
        formJSON,
        formData,
        themeObj,
        withSubmit
      }) => {
        commit('SET_FORM_DATA', formData)
        commit('SET_FORM_SOURCE_JSON', formJSON)

        commit('SET_WITH_SUBMIT', withSubmit)
        
        // Reset submission metrics when pushing new form source
        if (withSubmit) {
          console.log('🔄 [PREVIEW DEBUG] Resetting submission metrics for new form session')
          dispatch('submission_metrics/resetSubmissionMetrics')
        }

        await dispatch('submission/generateFormSubmission', formJSON)

        dispatch('setFieldsValidation')

        dispatch('FSP_theme/pushThemeObj', themeObj)

        dispatch('FSP/initializeFSP')
        
        // Initialize submission metrics for submittable forms
        if (withSubmit) {
          dispatch('submission_metrics/formSubmitOpened')
        }
      },


      setCurrentPageID: ({ commit }, pageID) => {
        commit('SET_CURRENT_PAGE_ID', pageID)
      },
      goToPreviousPage: ({ commit, getters }) => {
        let previousPageID

        if (getters.isMainPage) {
          if (getters.isFormStatic) {
            return
          } else if (getters.isFormInteractive) {
            !getters.getFormSourceJSON.main_pages.slice(0, getters.getCurrentMainPageIndex)
              .reverse()
              .some(({ page_id }) => {
                if (
                  !(getters.getFormSourceJSON.all_pages[page_id].field_id in getters['conditional/getFieldsWithExistenceStatus'])
                  || getters['conditional/getFieldsWithExistenceStatus'][getters.getFormSourceJSON.all_pages[page_id].field_id].exist
                ) {
                  previousPageID = page_id
                  return true
                }
              })
          }
        }
        commit('SET_CURRENT_PAGE_ID', previousPageID)
      },
      goToNextPage: ({ commit, getters, dispatch }) => {
        
        let nextPageID
        const mainPages = getters.getFormSourceJSON.main_pages
        const currentPageID = getters.getCurrentPageID

        if (getters.isHomePage) {
          nextPageID = mainPages[0].page_id
        } else if (getters.isMainPage) {
          if (getters.isFormStatic) {
            // In static forms, check for skip logic in ALL fields on current page
            let jumpToFieldId = null
            const currentPageFields = getters.getFieldsGroupedByPages[currentPageID] || []
            
            for (const fieldId of currentPageFields) {
              if (getters['conditional/getFieldsWithExistenceStatus'][fieldId]?.jump_to) {
                jumpToFieldId = getters['conditional/getFieldsWithExistenceStatus'][fieldId].jump_to
                break
              }
            }
            
            if (jumpToFieldId) {
              // Handle special destination types first (before searching for field IDs)
              if (jumpToFieldId === '__END_SURVEY__') {
                return dispatch('goToFinishPage')
              } else if (jumpToFieldId === '__THANK_YOU__') {
                return dispatch('goToFinishPage')
              } else if (jumpToFieldId === '__REDIRECT_URL__') {
                // Find the field data to get the redirect URL
                let redirectUrl = null
                for (const fieldId of currentPageFields) {
                  const fieldData = getters['conditional/getFieldsWithExistenceStatus'][fieldId]
                  if (fieldData?.jump_to === '__REDIRECT_URL__' && fieldData?.redirect_url) {
                    redirectUrl = fieldData.redirect_url
                    break
                  }
                }
                
                if (redirectUrl) {
                  // Execute redirect IMMEDIATELY while user action context is preserved
                  let normalizedUrl = redirectUrl.trim();
                  if (!normalizedUrl.startsWith('https://') && !normalizedUrl.startsWith('http://')) {
                    normalizedUrl = 'https://' + normalizedUrl;
                  }
                  
                  try {
                    // Use window.location.href to redirect in the same tab
                    window.location.href = normalizedUrl;
                  } catch (error) {
                    alert(`No se pudo redirigir automáticamente. Por favor, visita: ${normalizedUrl}`);
                  }
                }
                
                // After executing redirect, go to finish page
                return dispatch('goToFinishPage')
              }
              
              // For static forms, we need to find which PAGE contains the target field
              const fieldsGroupedByPages = getters.getFieldsGroupedByPages
              let targetPageId = null
              
              // Search through all pages to find which one contains the target field
              for (const [pageId, fieldIds] of Object.entries(fieldsGroupedByPages)) {
                if (fieldIds.includes(jumpToFieldId)) {
                  targetPageId = pageId
                  break
                }
              }
              
              if (targetPageId && targetPageId !== currentPageID) {
                // Only navigate if target is on a DIFFERENT page
                nextPageID = targetPageId
                
                // Schedule auto-scroll to the specific target field after navigation
                setTimeout(() => {
                  dispatch('scrollToField', jumpToFieldId)
                }, 100)
              } else if (targetPageId === currentPageID) {
                // Target field is on the same page - just scroll to it and proceed with normal navigation
                dispatch('scrollToField', jumpToFieldId)
                
                if (mainPages[mainPages.length - 1].page_id === currentPageID) {
                  return dispatch('goToFinishPage')
                } else {
                  // Find next page that should be visible
                  const currentPageIndex = mainPages.findIndex(page => page.page_id === currentPageID)
                  
                  if (currentPageIndex !== -1 && currentPageIndex < mainPages.length - 1) {
                    // Check each subsequent page to find the next visible one
                    for (let i = currentPageIndex + 1; i < mainPages.length; i++) {
                      const candidatePage = mainPages[i]
                      const candidatePageFieldId = getters.getFormSourceJSON.all_pages[candidatePage.page_id].field_id
                      
                      // If this field should exist (is visible), go to this page
                      if (getters['conditional/getFieldsWithExistenceStatus'][candidatePageFieldId]?.exist !== false) {
                        nextPageID = candidatePage.page_id
                        break
                      }
                    }
                    
                    // If no visible page found, go to finish page
                    if (!nextPageID) {
                      return dispatch('goToFinishPage')
                    }
                  } else {
                    return dispatch('goToFinishPage')
                  }
                }
              } else {
                // Fall back to normal navigation
                if (mainPages[mainPages.length - 1].page_id === currentPageID)
                  return dispatch('goToFinishPage')
                else
                  nextPageID = mainPages.find((page, index) => mainPages[index - 1]?.page_id === currentPageID).page_id
              }
            } else {
              // Normal static form navigation
              if (mainPages[mainPages.length - 1].page_id === currentPageID) {
                return dispatch('goToFinishPage')
              } else {
                // Find next page that should be visible
                const currentPageIndex = mainPages.findIndex(page => page.page_id === currentPageID)
                
                if (currentPageIndex !== -1 && currentPageIndex < mainPages.length - 1) {
                  // Check each subsequent page to find the next visible one
                  for (let i = currentPageIndex + 1; i < mainPages.length; i++) {
                    const candidatePage = mainPages[i]
                    const candidatePageFieldId = getters.getFormSourceJSON.all_pages[candidatePage.page_id].field_id
                    
                    // If this field should exist (is visible), go to this page
                    if (getters['conditional/getFieldsWithExistenceStatus'][candidatePageFieldId]?.exist !== false) {
                      nextPageID = candidatePage.page_id
                      break
                    }
                  }
                  
                  // If no visible page found, go to finish page
                  if (!nextPageID) {
                    return dispatch('goToFinishPage')
                  }
                } else {
                  return dispatch('goToFinishPage')
                }
              }
            }
          } else if (getters.isFormInteractive) {
            if (
              getters.getCurrentPage.field_id in getters['conditional/getFieldsWithExistenceStatus']
              && getters['conditional/getFieldsWithExistenceStatus'][getters.getCurrentPage.field_id].jump_to
            ) {
              const jumpToFieldId = getters['conditional/getFieldsWithExistenceStatus'][getters.getCurrentPage.field_id].jump_to
              const currentFieldData = getters['conditional/getFieldsWithExistenceStatus'][getters.getCurrentPage.field_id]
              
              // Handle special destination types
              if (jumpToFieldId === '__END_SURVEY__') {
                return dispatch('goToFinishPage')
              } else if (jumpToFieldId === '__THANK_YOU__') {
                return dispatch('goToFinishPage')
              } else if (jumpToFieldId === '__REDIRECT_URL__') {
                const redirectUrl = currentFieldData.redirect_url
                
                if (redirectUrl) {
                  // Execute redirect IMMEDIATELY while user action context is preserved
                  let normalizedUrl = redirectUrl.trim();
                  if (!normalizedUrl.startsWith('https://') && !normalizedUrl.startsWith('http://')) {
                    normalizedUrl = 'https://' + normalizedUrl;
                  }
                  
                  try {
                    // Use window.location.href to redirect in the same tab
                    window.location.href = normalizedUrl;
                  } catch (error) {
                    alert(`No se pudo redirigir automáticamente. Por favor, visita: ${normalizedUrl}`);
                  }
                }
                
                // After executing redirect, go to finish page
                return dispatch('goToFinishPage')
              } else {
                // Regular field ID jump
                const targetPageEntry = Object.entries(getters.getFormSourceJSON.all_pages)
                  .find(([, { field_id }]) => field_id === jumpToFieldId)
                
                if (targetPageEntry) {
                  nextPageID = targetPageEntry[0]
                }
              }
            } else if (!getters.getFormSourceJSON.main_pages.slice(getters.getCurrentMainPageIndex + 1)
              .some(({ page_id }) => {
                if (
                  !(getters.getFormSourceJSON.all_pages[page_id].field_id in getters['conditional/getFieldsWithExistenceStatus'])
                  || getters['conditional/getFieldsWithExistenceStatus'][getters.getFormSourceJSON.all_pages[page_id].field_id].exist
                ) {
                  nextPageID = page_id
                  return true
                }
              })
            ) return dispatch('goToFinishPage')

          }
        }
        
        // Ensure nextPageID is valid before committing
        if (nextPageID) {
          commit('SET_CURRENT_PAGE_ID', nextPageID)
        }
      },
      scrollToField: ({ }, fieldId) => {
        
        // Function to attempt scrolling with retries
        const attemptScroll = (retries = 0) => {
          const fieldElement = document.querySelector(`.generic-field--${fieldId}`)
          
          if (fieldElement) {
            
            // Use Vue's $vuetify.goTo if available
            const appElement = document.querySelector('.v-application') || document.body
            
            if (window.Vue && window.Vue.prototype.$vuetify) {
              window.Vue.prototype.$vuetify.goTo(fieldElement, {
                duration: 500,
                offset: 150,
                container: appElement
              })
            } else {
              // Fallback to native scrollIntoView
              fieldElement.scrollIntoView({ 
                behavior: 'smooth', 
                block: 'start',
                inline: 'nearest'
              })
            }
          } else if (retries < 10) {
            // Retry up to 10 times with increasing delays
            setTimeout(() => attemptScroll(retries + 1), 200 + (retries * 100))
          }
        }
        
        // Start attempting scroll after a short delay
        setTimeout(() => attemptScroll(), 300)
      },
      registerBeforeSubmitHook: ({ commit }, { hookID, hook }) => {
        commit('REGISTER_BEFORE_SUBMIT_HOOK', { hookID, hook })
      },

      validateMainPage: ({ getters, dispatch }, pageID) => Promise.all(
        getters.getFieldsGroupedByPages[pageID].map(fieldID => !getters['conditional/getFieldsWithExistenceStatus'][fieldID]?.exist || dispatch('fields_validation/validateField', fieldID))
      )
        .then(results => results.every(result => result)),
      validateCurrentMainPage: ({ dispatch, getters }) => dispatch('validateMainPage', getters.getCurrentPageID),
      goToFinishPage: async ({ commit, getters, dispatch }) => {
        
        // if interactive form (for static form pages are validated before nextPage action is called)
        if (getters.isFormInteractive) {
          for (let mainPage of getters.getFormPages) {
            const result = await dispatch('validateMainPage', mainPage.page_id)
            if (!result)
              return dispatch('setCurrentPageID', mainPage.page_id)
          }
        }
        
        // Handle redirects BEFORE submitting to preserve user action context
        let redirectUrl = null;
        
        // Check for conditional redirect first (from skip logic)
        if (getters.getConditionalRedirectUrl && getters.getConditionalRedirectUrl.trim()) {
          redirectUrl = getters.getConditionalRedirectUrl.trim();
          // Clear the conditional redirect URL after use
          commit('SET_CONDITIONAL_REDIRECT_URL', null);
        } else {
          // Check for skip logic redirect on current page (for static forms with Submit button)
          if (getters.isFormStatic) {
            const currentPageFields = getters.getFieldsGroupedByPages[getters.getCurrentPageID] || []
            
            for (const fieldId of currentPageFields) {
              const fieldData = getters['conditional/getFieldsWithExistenceStatus'][fieldId]
              if (fieldData?.jump_to === '__REDIRECT_URL__' && fieldData?.redirect_url) {
                redirectUrl = fieldData.redirect_url
                break
              }
            }
          }
          
          // If no skip logic redirect, check if general redirect is configured
          if (!redirectUrl) {
            const { redirect_upon_completion } = getters.getFormSourceJSON.settings.general_settings;
            if (redirect_upon_completion && redirect_upon_completion.trim()) {
              redirectUrl = redirect_upon_completion.trim();
            }
          }
        }
        
        // Execute redirect FIRST if we have a URL (while user action context is preserved)
        if (redirectUrl) {
          // Normalize URL to ensure it has a protocol
          let normalizedUrl = redirectUrl;
          if (!normalizedUrl.startsWith('https://') && !normalizedUrl.startsWith('http://')) {
            normalizedUrl = 'https://' + normalizedUrl;
          }
          
          // Execute redirect immediately while user action context is still active
          try {
            // Use window.location.href to redirect in the same tab
            window.location.href = normalizedUrl;
            
          } catch (error) {
            // If redirect failed, show user the URL
            alert(`No se pudo redirigir automáticamente. Por favor, visita: ${normalizedUrl}`);
          }
        }
        
        // Submit the form after handling redirect
        await dispatch('submitForm')
        
        // Show the thank you page
        commit('SET_CURRENT_PAGE_ID', getters.getFormSourceJSON.finish_page.page_id);
      },
      submitForm: async ({ getters, dispatch }) => {
        if (getters.getWithSubmit) {
          if (!getters.getFormVersionId) throw 'Submit error: form version ID unset'

          await Promise.all(
            Object.values(getters.getBeforeSubmitHooks).map(hook => hook())
          )

          const submitResult = await FormSubmitActions.submitForm(
            getters['submission_metrics/getSubmissionId'],
            getters.getFormData.id,
            getters.getFormVersionId,
            getters['submission/getFormSubmission'],
            getters.getFormData.zapier_status,
            getters.getFormData.webhook_url,
          )

          // Resetear el estado después de un envío exitoso para permitir múltiples envíos
          await Promise.all([
            dispatch('submission_metrics/resetAfterSubmit'),
            dispatch('submission/resetAfterSubmit')
          ])

          return submitResult
        }
      }
    },
    getters: {
      //getFormSourceJSON: ({ state }) => state.form_source_json,
      getFormSourceJSON: ({ state }) => {
        const formJSON = state.form_source_json;
        if (formJSON && !formJSON?.layout_header_style) {
          formJSON.layout_header_style = 'visible_header';
        }
        return formJSON;
      },
      getFormData: ({ state }) => state.form_data,

      isFormFullyLoaded: ({ getters }) => !!((getters.getFormData || !getters.getWithSubmit) && (getters.getFormSourceJSON && getters['submission/getFormSubmission'])),

      isFormStatic: ({ getters }) => getters.isFormFullyLoaded && getters.getFormSourceJSON.form_type === constants.FORM_TYPES.STATIC_FORM.FORM_TYPE,
      isFormInteractive: ({ getters }) => getters.isFormFullyLoaded && getters.getFormSourceJSON.form_type === constants.FORM_TYPES.INTERACTIVE_FORM.FORM_TYPE,

      getFormPages: ({ getters }) => getters.getFormSourceJSON.main_pages,
      getCurrentPageID: ({ state }) => state.current_page_id,
      getCurrentPage: ({ getters }) => getters.getFormSourceJSON?.all_pages?.[getters.getCurrentPageID],
      getFieldsGroupedByPages: ({ getters }) => {
        if (getters.isFormStatic)
          return Object.fromEntries(
            getters.getFormPages
              .map(({ page_id }) => [
                page_id,
                getters.getFormSourceJSON.all_pages[page_id].rows
                  .map(({ fields }) => fields)
                  .flat()
                  .map(({ field_id }) => field_id)
              ])
          )
        else if (getters.isFormInteractive)
          return Object.fromEntries(
            getters.getFormPages
              .map(({ page_id }) => [
                page_id,
                [getters.getFormSourceJSON.all_pages[page_id].field_id]
              ])
          )
        return []
      },
      getMainPagesWithIndexes: ({ getters }) => Object.fromEntries(getters.getFormPages.map(({ page_id }, index) => [page_id, index])),
      getCurrentMainPageIndex: ({ getters }) => getters.getFormSourceJSON.main_pages.findIndex(p => p.page_id === getters.getCurrentPageID),

      isHomePage: ({ getters }) => getters.getCurrentPage?.type === constants.FORM_PAGES_TYPES.HOME_PAGE,
      isMainPage: ({ getters }) => getters.getCurrentPage?.type === constants.FORM_PAGES_TYPES.MAIN_PAGE,
      isFinishPage: ({ getters }) => getters.getCurrentPage?.type === constants.FORM_PAGES_TYPES.FINISH_PAGE,
      
      getConditionalRedirectUrl: ({ state }) => state.conditional_redirect_url,
    }
  }
}
